module.exports = __webpack_public_path__ + "img/134.b903ec8d.jpg";